import React from 'react';
import { Box, Button, FormHelperText, Typography } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import TagEditor from '../Widgets/TagEditor';

const ActionPathField = ({
  browseDisabled = false,
  browseLabel,
  caseid,
  disabled = false,
  error = false,
  helperText,
  label,
  onBrowse,
  onChange,
  placeholder,
  tags,
  value,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'stretch', sm: 'flex-start' },
      gap: 1,
    }}
  >
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 0.5, display: 'block' }}
      >
        {label}
      </Typography>
      <TagEditor
        caseid={caseid}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        singleLine
        disabled={disabled}
        tags={tags}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
    {onBrowse && (
      <Button
        variant="outlined"
        startIcon={<FolderOpenIcon />}
        onClick={onBrowse}
        disabled={disabled || browseDisabled}
        sx={{
          mt: { xs: 0, sm: 3 },
          alignSelf: { xs: 'stretch', sm: 'flex-start' },
          minWidth: { sm: 150 },
          textTransform: 'none',
        }}
      >
        {browseLabel}
      </Button>
    )}
  </Box>
);

export default React.memo(ActionPathField);
